/*
(function($) {

	'use strict'

    
	var init = function() {
        MyAjax.paged = 1;
        MyAjax.maxNumPages = parseInt($('.list__info').data('max-num-pages'));
        if(MyAjax.maxNumPages > 1){
            $(window).scroll(initInfiniteScroll);
        }
	}
    
    var initInfiniteScroll = function(){
        var scrollPosition = $(window).height() + $(window).scrollTop();
        var scrollListBottom = $('.list__info').offset().top + $('.list__info').outerHeight();
        if( !MyAjax.loading && scrollPosition >= scrollListBottom){
            setLoading(true);
            loadMore();
        }
    }

    var setLoading = function(loading){
        loading = Boolean(loading);
        MyAjax.loading = loading;
        var loader = $('.list__info__more__loader');
        if(loading && !loader.hasClass('active')){
            loader.addClass('active');
        } else if(!loading && loader.hasClass('active')) {
            loader.removeClass('active');
        }
    }

    var loadMore = function() {
        var beforeScrollTop = $(window).scrollTop();
        MyAjax.data = {
            action  	: 'info_more_results',
            paged		: ++MyAjax.paged,
        };
        $.ajax({
            url : MyAjax.ajaxurl,
            data: MyAjax.data,
            type: 'POST',
            success: function(response) {
                var json = jQuery.parseJSON(response)
                var $contents = $(json.contents)
                if($contents.length > 0){
                    $('.list__info').append($contents);
                } else {
                    $(window).unbind('scroll', initInfiniteScroll);
                }
            },
            error: function(response) {
                console.error(response);
                $(window).unbind('scroll', initInfiniteScroll);
            },
            complete: function(response) {
                if(MyAjax.paged >= MyAjax.maxNumPages){
                    $(window).unbind('scroll', initInfiniteScroll);
                }
                setLoading(false);
            }
        })
    }

	$(document).ready(function() {
        if($('div').hasClass('list__info')) {
            init()
        }
	})

})(jQuery)

*/